import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ServiceType,
  EnterpriseSearchService,
  WithSubscriptionComponent,
  IrlJourneyType
} from '@sabstravtech/obtservices/angular';
import { LocationTypes, LocationDetails } from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-search-toggle',
  templateUrl: './search-toggle.component.html',
  styleUrls: ['./search-toggle.component.scss'],
  standalone: false
})
export class SearchToggleComponent extends WithSubscriptionComponent implements OnInit {
  @Input() text = 'Search Form';
  @Input() toggleState = false;
  @Output() newToggleState: EventEmitter<boolean> = new EventEmitter();
  @Input() serviceType;
  @Input() isDTD = false;

  ServiceType: typeof ServiceType = ServiceType;
  public irlJourneyType: typeof IrlJourneyType = IrlJourneyType;
  public locationTypes: typeof LocationTypes = LocationTypes;
  searchArgs: any;
  officeName: string;

  constructor(public searchService: EnterpriseSearchService) {
    super();
  }

  ngOnInit() {
    this.initializeSearchArgs();
    if (this.serviceType === ServiceType.Hotel && this.searchArgs.officeId) {
      this.initializeOfficeName();
    }
  }

  toggle(): void {
    this.toggleState = !this.toggleState;
    this.newToggleState.emit(this.toggleState);

    if (!this.toggleState) {
      this.initializeSearchArgs();
    }
  }

  private initializeSearchArgs(): void {
    const searchInstance = this.searchService.searches[this.serviceType];

    if (this.isSearchTypeRequiringUpdate()) {
      this.searchArgs = searchInstance.updateSerchQuery(searchInstance.getSearchQuery());
    } else {
      this.searchArgs = searchInstance?.getSearchQuery();
    }
  }

  private initializeOfficeName(): void {
    this.subscribe(
      this.searchService.getOfficeLocationsNoUserAddresses(),
      (offices: LocationDetails[]) => {
        const office = offices.find(
          (office) => Number(office.id) === Number(this.searchArgs.officeId)
        );
        if (office) {
          this.officeName = office.name;
        }
      },
      (error) => console.error('Error fetching office locations:', error)
    );
  }

  private isSearchTypeRequiringUpdate(): boolean {
    return (
      this.serviceType === ServiceType.Car ||
      this.serviceType === ServiceType.Rail ||
      this.serviceType === ServiceType.InternationalRail
    );
  }
}
